import React from "react";
import FormControl from "@mui/material/FormControl";
import {
    Box,
    Button,
    Divider,
    FormControlLabel,
    IconButton,
    Paper,
    Radio,
    RadioGroup,
    Stack,
    TextField,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import RangePickerModalAnalysis from "src/components/range-picker-modal-analysis";
import styled from "styled-components";
import { format } from "date-fns";
import HistorySection from "src/scenes/causal-analysis/components/history-section";

const TimeFrameText = styled.p`
    margin: 0 19px 0 0;
    font-size: 12px;
`;

const HelperText = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 300;
    padding: 12px 0 12px 0;
`;

const CustomPaper = styled(Paper)`
    border-radius: 14px;
    width: 100%;
    min-height: 164px;
    z-index: 100;
`;

const PaperTitle = styled.p`
    margin: 0;
    padding: 7px 0 6px 18px;
    font-size: 12px;
    background-color: #5b5b5b;
    border-radius: 14px 14px 0 0;
`;
const AnalysisPicker = ({ handleGetGraph }) => {
    const [selectedValue, setSelectedValue] = React.useState("overall");
    const [selectedMrA, setSelectedMrA] = React.useState(undefined);
    const [selectedRepoA, setSelectedRepoA] = React.useState(undefined);
    const [selectedTime, setSelectedTime] = React.useState({ from: undefined, to: undefined });
    const [openDatepicker, setOpenDatepicker] = React.useState(false);
    const [analysisName, setAnalysisName] = React.useState(undefined);
    const [historyPanelOpen, setHistoryPanelOpen] = React.useState(false);

    const toggleDatepicker = () => setOpenDatepicker(!openDatepicker);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleMrChange = (event) => {
        setSelectedMrA(event.target.value);
    };

    const handleRepoChange = (event) => {
        setSelectedRepoA(event.target.value);
    };

    return (
        <>
            <Stack direction="column" alignItems="center">
                <CustomPaper>
                    <Stack direction="column" style={{ width: "100%" }}>
                        <PaperTitle>
                            Find out &quot;why?&quot; (we were faster or slower).
                        </PaperTitle>
                        <Stack direction="row" justifyContent="space-between">
                            <Stack direction="row">
                                <Box style={{ padding: "16px" }}>
                                    <HelperText>
                                        Select one of the following ways to analyse your data
                                    </HelperText>
                                    <FormControl>
                                        <RadioGroup
                                            row
                                            aria-labelledby="lead-time-analysis-buttons-group-row"
                                            name="lead-time-analysis-buttons-group"
                                            onChange={handleChange}
                                        >
                                            <FormControlLabel
                                                value="overall"
                                                control={
                                                    <Radio
                                                        size="small"
                                                        checked={selectedValue === "overall"}
                                                    />
                                                }
                                                label={
                                                    <Typography sx={{ fontSize: 12 }}>
                                                        Overall
                                                    </Typography>
                                                }
                                            />
                                            <FormControlLabel
                                                value="mrs"
                                                control={
                                                    <Radio
                                                        size="small"
                                                        checked={selectedValue === "mrs"}
                                                    />
                                                }
                                                label={
                                                    <Typography sx={{ fontSize: 12 }}>
                                                        Merge request
                                                    </Typography>
                                                }
                                            />
                                            <FormControlLabel
                                                value="repo"
                                                control={
                                                    <Radio
                                                        size="small"
                                                        checked={selectedValue === "repo"}
                                                    />
                                                }
                                                label={
                                                    <Typography sx={{ fontSize: 12 }}>
                                                        Repo
                                                    </Typography>
                                                }
                                            />
                                            <FormControlLabel
                                                value="time"
                                                control={
                                                    <Radio
                                                        size="small"
                                                        checked={selectedValue === "time"}
                                                    />
                                                }
                                                label={
                                                    <Typography sx={{ fontSize: 12 }}>
                                                        Time frames
                                                    </Typography>
                                                }
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Box>
                                <Divider orientation="vertical" variant="middle" flexItem />
                                <Box style={{ padding: "16px" }}>
                                    {selectedValue === "overall" && (
                                        <HelperText>
                                            Nice explanatory sentence about general
                                        </HelperText>
                                    )}
                                    {selectedValue === "mrs" && (
                                        <HelperText>Nice explanatory sentence about mrs</HelperText>
                                    )}
                                    {selectedValue === "repo" && (
                                        <HelperText>
                                            Nice explanatory sentence about repos
                                        </HelperText>
                                    )}
                                    {selectedValue === "time" && (
                                        <HelperText>
                                            Nice explanatory sentence about time
                                        </HelperText>
                                    )}
                                    {selectedValue === "mrs" && (
                                        <FormControl
                                            sx={{ m: 1, minWidth: 120 }}
                                            size="small"
                                            style={{ width: "264px" }}
                                        >
                                            <Select
                                                value={selectedMrA}
                                                onChange={handleMrChange}
                                                displayEmpty
                                                inputProps={{ "aria-label": "Without label" }}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value={10}>Ten</MenuItem>
                                                <MenuItem value={20}>Twenty</MenuItem>
                                                <MenuItem value={30}>Thirty</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {selectedValue === "repo" && (
                                        <FormControl
                                            sx={{ m: 1, minWidth: 120 }}
                                            size="small"
                                            style={{ width: "264px" }}
                                        >
                                            <Select
                                                value={selectedRepoA}
                                                onChange={handleRepoChange}
                                                displayEmpty
                                                inputProps={{ "aria-label": "Without label" }}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value={10}>Ten</MenuItem>
                                                <MenuItem value={20}>Twenty</MenuItem>
                                                <MenuItem value={30}>Thirty</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {selectedValue === "time" && (
                                        <Stack direction="row" alignItems="center">
                                            {!selectedTime.from || !selectedTime.to ? (
                                                <TimeFrameText>No timeframe selected</TimeFrameText>
                                            ) : (
                                                <TimeFrameText>
                                                    From{" "}
                                                    {format(
                                                        new Date(selectedTime.from),
                                                        "EEE d MMM YYY"
                                                    )}{" "}
                                                    to{" "}
                                                    {format(
                                                        new Date(selectedTime.to),
                                                        "EEE d MMM YYY"
                                                    )}
                                                </TimeFrameText>
                                            )}
                                            <Button
                                                variant="outlined"
                                                color="secondary"
                                                onClick={toggleDatepicker}
                                            >
                                                Select Dates
                                            </Button>
                                        </Stack>
                                    )}
                                </Box>
                                <Divider orientation="vertical" variant="middle" flexItem />
                                <Box style={{ padding: "16px" }}>
                                    <HelperText>Set a name for your analysis</HelperText>
                                    <TextField
                                        id="outlined-controlled"
                                        label="Controlled"
                                        size="small"
                                        value={analysisName}
                                        onChange={(event) => {
                                            setAnalysisName(event.target.value);
                                        }}
                                        style={{ margin: "8px" }}
                                    />
                                </Box>
                            </Stack>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleGetGraph()}
                                startIcon={<PlayCircleOutlineIcon />}
                                style={{ margin: "32px" }}
                            >
                                Start Analysis
                            </Button>
                        </Stack>
                        <IconButton
                            aria-label="show-history"
                            style={{ marginLeft: "50%", marginTop: "16px", width: "40px" }}
                            onClick={() => setHistoryPanelOpen(!historyPanelOpen)}
                        >
                            {historyPanelOpen ? (
                                <ExpandCircleDownIcon style={{ rotate: "180deg" }} />
                            ) : (
                                <ExpandCircleDownIcon />
                            )}
                        </IconButton>
                    </Stack>
                </CustomPaper>
                {historyPanelOpen && <HistorySection />}
            </Stack>
            <RangePickerModalAnalysis
                open={openDatepicker}
                handleClose={() => setOpenDatepicker(false)}
                toggleDatepicker={toggleDatepicker}
                setSelectedTime={setSelectedTime}
            />
        </>
    );
};

export default AnalysisPicker;
